module.exports = __webpack_public_path__ + "static/media/green-red-triangle.f4abaf0c.jpg";